import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { motion } from "framer-motion";

import Jumbotron from "../components/Jumbotron";
import PageGenerator from "../components/Project/PageGenerator";
import ProjectNavigation from "../components/Project/ProjectNativation";

import ProjectsList from '../components/Project/ProjectsList.json';

const Project = () => {
    const navigate = useNavigate();
    const { handle } = useParams();

    const PROJECT = ProjectsList.find((e) => e.handle === handle);
    
    useEffect(() => {
        if (!PROJECT) {
            navigate('/');
            return;
        }

        document.title = "Project " + PROJECT.title;
    });

    if (!PROJECT) return null;

    const imageUrl = require(`../assets/projects/${PROJECT.image}`);

    return (
        <> 
            <motion.div
                initial={{ translateX: 50, opacity: 0 }}
                animate={{ translateX: 0, opacity: 1 }}
                exit={{ translateX: 50, opacity: 0 }}
                transition={{ duration: 0.6, ease: [0.43, 0.13, 0.23, 0.96] }}>
                <Jumbotron 
                    title={PROJECT.title} 
                    desc={PROJECT.desc} 
                    stack={PROJECT.stack} 
                    type={PROJECT.type}
                    image={imageUrl}
                    urls={PROJECT.urls} />
                <PageGenerator schema={PROJECT.schema} />
                <ProjectNavigation />
            </motion.div>
        </>
    );
};

export default Project;